import { render, staticRenderFns } from "./FiltersTab.vue?vue&type=template&id=418af719&scoped=true"
import script from "./FiltersTab.vue?vue&type=script&lang=js"
export * from "./FiltersTab.vue?vue&type=script&lang=js"
import style0 from "./FiltersTab.vue?vue&type=style&index=0&id=418af719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418af719",
  null
  
)

export default component.exports